import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import './IntroDashboard.scss'
import { withCookies, Cookies } from 'react-cookie'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import Highcharts from 'highcharts'
import more from 'highcharts/highcharts-more'
import stream from 'highcharts/modules/streamgraph'
import StackGrid from 'react-stack-grid'
import ImageZoom from 'react-medium-image-zoom'
// import HC_exporting from 'highcharts/modules/exporting'
import HC_annotation from 'highcharts/modules/annotations'
import HC_seriesLabel from 'highcharts/modules/series-label'
import HighchartsReact from 'highcharts-react-official'

// HC_exporting(Highcharts)
HC_annotation(Highcharts)
HC_seriesLabel(Highcharts)

const Comma = (num) => {
    if (typeof num === 'number') {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } else {
        return ''
    }
}

const scoreChartOptions = {
    chart: {
        polar: true,
        type: 'line',
        height: 350,
    },

    title: {
        text: '현장 관리 지수',
        style: {},
    },

    subtitle: {
        text: '항목별 종합적인 평가 지수입니다.',
        style: {},
    },

    pane: {
        size: '85%',
    },

    xAxis: {
        categories: ['총점', '공정표', '작업보고', 'CCTV', '소통'],
        tickmarkPlacement: 'on',
        lineWidth: 0,
        labels: {
            distance: 5,
        },
    },

    yAxis: {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
    },

    tooltip: {
        shared: true,
        pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y:,.0f}</b><br/>',
    },

    legend: {
        enabled: false,
    },
}

const pieChartOptions = {
    chart: {
        type: 'pie',
        marginTop: 60,
        marginBottom: 20,
        height: 350,
    },
    title: {
        text: '공정별 인원 현황',
        style: {},
    },

    subtitle: {
        text: '공정별 투입된 작업 인원수 비율입니다.',
        style: {},
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.y}</b>',
    },
    colors: [
        '#D3F8E2',
        '#E4C1F9',
        '#F694C1',
        '#EDE7B1',
        '#A9DEF9',
        '#FFE787',
        '#FFF8BC',
        '#FFAF92',
        '#FF876F',
        '#876C5C',
        '#DCD8D4',
        '#F8C785',
        '#E38E73',
        '#FCE883',
        '#88D8C1',
        '#AF6E4D',
        '#E0BBE4',
        '#FEC8D8',
        '#FFDFD3',
        '#CFBAE1',
        '#F2E9E0',
        '#C4C4C4',
    ],
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                style: {
                    fontWeight: 'normal',
                    color: '#666666',
                },
            },
        },
    },
}

const lineChartOptions = {
    chart: {
        type: 'line',
        height: 400,
    },
    title: {
        text: '누적 인원 현황',
        style: {},
    },

    subtitle: {
        text: '현재까지 투입된 작업 인원수 정보 입니다.',
        style: {},
    },
    yAxis: [
        {
            title: {
                text: '누적 인원수',
            },
        },
    ],
    xAxis: {
        title: {
            text: '작업일수',
            style: {
                display: 'none',
            },
        },
        labels: {
            formatter: function() {
                return moment(new Date(this.value)).format('MM/DD')
            },
        },
    },
    plotOptions: {
        series: {
            label: {
                connectorAllowed: false,
            },
            pointStart: 1,
        },
    },
    legend: {
        enabled: false,
    },
}

const streamChartOptions = {
    chart: {
        type: 'streamgraph',
        zoomType: 'x',
        height: 480,
    },
    title: {
        text: '주단위 공정 분포도',
        style: {},
    },

    subtitle: {
        text: '공정별 분포도, 집중도를 주간단위로 표시합니다.',
        style: {},
    },
    xAxis: {
        title: {
            text: '날짜',
            style: {
                display: 'none',
            },
        },
        labels: {
            formatter: function() {
                return moment(new Date(this.value)).format('MM/DD')
            },
        },
    },
    yAxis: [
        {
            visible: true,
            startOnTick: false,
            endOnTick: false,
            labels: {
                enabled: true,
            },
            title: {
                enabled: true,
                text: '주간 인원수',
            },
        },
        {
            visible: true,
            title: {
                text: ' ',
            },
            labels: {
                enabled: true,
            },
            gridLineWidth: 0,
            opposite: true,
            startOnTick: false,
            endOnTick: false,
        },
    ],
    colors: [
        '#D3F8E2',
        '#E4C1F9',
        '#F694C1',
        '#EDE7B1',
        '#A9DEF9',
        '#FFE787',
        '#FFF8BC',
        '#FFAF92',
        '#FF876F',
        '#876C5C',
        '#DCD8D4',
        '#F8C785',
        '#E38E73',
        '#FCE883',
        '#88D8C1',
        '#AF6E4D',
        '#E0BBE4',
        '#FEC8D8',
        '#FFDFD3',
        '#CFBAE1',
        '#F2E9E0',
        '#C4C4C4',
    ],
    plotOptions: {
        series: {
            label: {
                minFontSize: 3,
                maxFontSize: 20,
                style: {
                    color: '#000000',
                    fontWeight: 'normal',
                },
                connectorNeighbourDistance: 10,
                connectorAllowed: true,
            },
        },
        streamgraph: {},
    },
    legend: {
        enabled: false,
    },
}

const HistoryTitle = ({ row }) => <div>{row.process}</div>

const HistorySchedule = ({ row }) => (
    <div>
        {moment(row.startDate).format('YYYY-MM-DD')} - {moment(row.endDate).format('YYYY-MM-DD')}
    </div>
)

const HistoryReason = ({ row }) => <div>{row.reason}</div>

const historyColumns = [
    {
        name: '공종',
        selector: 'process',
        sortable: true,
        width: '120px',
        cell: (row) => <HistoryTitle row={row} />,
    },
    {
        name: '변경 스케쥴',
        selector: 'start_date',
        sortable: true,
        width: '180px',
        cell: (row) => <HistorySchedule row={row} />,
    },
    {
        name: '사유',
        selector: 'reason',
        cell: (row) => <HistoryReason row={row} />,
    },
]

class IntroDashboard extends Component {
    constructor(props) {
        super(props)

        this.scoreChartRef = React.createRef()
        this.pieChartRef = React.createRef()
        this.lineChartRef = React.createRef()
        this.streamChartRef = React.createRef()
    }

    componentDidMount() {
        //this.loadScore()
        this.loadTimeline()
        window.scrollTo(0, 0)
    }

    buildChart = (res) => {
        // 공정별 인원 현황 차트
        const processWorker = []
        for (let i = 0; i < res.workerCountPerProcess.length; i += 1) {
            const processTitle = res.workerCountPerProcess[i].process.title
            const workerNum = res.workerCountPerProcess[i].workerNum
            processWorker.push({ name: processTitle, y: workerNum })
        }

        const pieChart = {
            name: '인원수',
            data: processWorker,
        }
        this.refs.pieChartRef.chart.addSeries(pieChart)

        // 누적 인원 현황
        const totalDailyWorks = []
        let accNum = 0
        for (let i = 0; i < res.accumulationWorkers.length; i += 1) {
            const workDate = new Date(res.accumulationWorkers[i].date)
            const workerNum = res.accumulationWorkers[i].workerNum
            accNum += workerNum
            const work = {
                x: workDate,
                y: accNum,
            }
            totalDailyWorks.push(work)
        }

        const accWokers = {
            name: '누적 작업자수',
            data: totalDailyWorks,
            zindex: 1,
            color: '#24524A',
        }
        this.refs.lineChartRef.chart.addSeries(accWokers)

        // streamchart
        let chartData = []
        res.processDistributionPerWeek.graphData.forEach((data) => {
            chartData.push({
                name: data.processTitle,
                data: data.data,
            })
        })
        this.refs.streamChartRef.chart.xAxis[0].setCategories(res.processDistributionPerWeek.dates)
        this.refs.streamChartRef.chart.update({ series: chartData }, true, true)
    }

    buildHistory = (data) => {
        if (data.length > 0) {
            const history = []
            data.forEach(function(process) {
                if (process.history.length > 0) {
                    process.history.forEach(function(log) {
                        const item = {
                            processId: process.processId,
                            process: process.text,
                            startDate: log.startDate,
                            endDate: log.endDate,
                            reason: log.reason,
                            writeDate: process.writeDate,
                        }
                        history.push(item)
                    })
                }
            })

            const ret = history.sort(function(a, b) {
                return a.writeDate - b.writeDate
            })

            this.setState({ history: ret })
        }
    }

    buildScore = (data) => {
        const project = {
            name: '관리 지수',
            data: [
                Number(data.totalScore),
                Number(data.processScore),
                Number(data.reportScore),
                Number(data.cctvScore),
                Number(data.comunicationScore),
            ],
            pointPlacement: 'on',
            color: '#24524A',
            label: {
                enabled: false,
            },
        }

        this.refs.scoreChartRef.chart.addSeries(project)
    }

    loadTimeline = () => {
        axios
            .get(`${BACKEND_HOST}/projects/${this.props.cookies.get('project')}/dashboard`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.buildScore(res.data.projectScore)
                this.buildChart(res.data)
                // this.buildHistory2(res.data.scheduleRevisions)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    buildHistory2 = (history) => {
        const result = []
        const List = history.map((data, i) => {
            const newDate = new Date(data.updatedAt)
            const newYear = newDate.getFullYear()
            const week = new Array('일', '월', '화', '수', '목', '금', '토')
            const newDayName = week[newDate.getDay()]

            let newMonth = newDate.getMonth() + 1
            if (newMonth < 10) {
                newMonth = '0' + newMonth
            }
            let newDay = newDate.getDate()
            if (newDay < 10) {
                newDay = '0' + newDay
            }

            const newDate2 = new Date(data.updatedAt)
            const newYear2 = newDate2.getFullYear()
            const week2 = new Array('일', '월', '화', '수', '목', '금', '토')
            const newDayName2 = week2[newDate2.getDay()]

            let newMonth2 = newDate2.getMonth() + 1
            if (newMonth2 < 10) {
                newMonth2 = '0' + newMonth2
            }
            let newDay2 = newDate2.getDate()
            if (newDay2 < 10) {
                newDay2 = '0' + newDay2
            }

            const newDate3 = new Date(data.updatedAt)
            const newYear3 = newDate3.getFullYear()
            const week3 = new Array('일', '월', '화', '수', '목', '금', '토')
            const newDayName3 = week3[newDate3.getDay()]

            let newMonth3 = newDate3.getMonth() + 1
            if (newMonth3 < 10) {
                newMonth3 = '0' + newMonth3
            }
            let newDay3 = newDate3.getDate()
            if (newDay3 < 10) {
                newDay3 = '0' + newDay3
            }

            let newHours = newDate3.getHours()
            if (newHours < 10) {
                newHours = '0' + newHours
            }
            let newMinutes = newDate3.getMinutes()
            if (newMinutes < 10) {
                newMinutes = '0' + newMinutes
            }

            // compare detaledDiff(befor, after)
            const history = []
            let diff = {}
            const taskLength = Math.max(
                i == 0 ? this.state.process.process.tasks.length : this.state.process.revisions[i - 1].tasks.length,
                data.tasks.length
            )

            data.tasks.forEach((task) => {
                diff = detailedDiff(
                    data.tasks,
                    i == 0 ? this.state.process.process.tasks : this.state.process.revisions[i - 1].tasks
                )
            })

            const reason = data.editReason !== '' ? data.editReason : '사유없음'

            if (diff) {
                if (diff.added) {
                    for (let j = 0; j < taskLength; j++) {
                        if (j in diff.added) {
                            const item = diff.added[j]
                            let chanageContent = '[추가] '
                            chanageContent +=
                                '' +
                                item.text +
                                ' ' +
                                moment(item.startDate).format('YYYY-MM-DD') +
                                ' ~ ' +
                                moment(item.endDate).format('YYYY-MM-DD')
                            history.push(chanageContent)
                        }
                    }
                }

                if (diff.updated) {
                    for (let j = 0; j < taskLength; j++) {
                        if (j in diff.updated) {
                            const item = diff.updated[j]
                            let chanageContent = '[수정] '

                            let beforeText = data.tasks[j].text
                            let beforeStartDate = data.tasks[j].startDate
                            let beforeEndDate = data.tasks[j].endDate
                            chanageContent +=
                                '' +
                                beforeText +
                                ' ' +
                                moment(beforeStartDate).format('MM-DD') +
                                ' ~ ' +
                                moment(beforeEndDate).format('MM-DD') +
                                ' => '

                            let changedText = item.text ? item.text : data.tasks[j].text
                            let changedStartDate = item.startDate ? item.startDate : data.tasks[j].startDate
                            let changedEndDate = item.endDate ? item.endDate : data.tasks[j].endDate
                            chanageContent +=
                                '' +
                                changedText +
                                ' ' +
                                moment(changedStartDate).format('MM-DD') +
                                ' ~ ' +
                                moment(changedEndDate).format('MM-DD')
                            history.push(chanageContent)
                        }
                    }
                }

                if (diff.deleted) {
                    for (let j = 0; j < taskLength; j++) {
                        if (j in diff.deleted) {
                            const item = diff.deleted[j]
                            let chanageContent = '[삭제] '
                            let changedText = data.tasks[j].text
                            chanageContent += '' + changedText + ''
                            history.push(chanageContent)
                        }
                    }
                }
            }

            // return (
            //     <div className="history_item" key={i}>
            //         <div className="history_content">
            //             <div className="history_reason">{reason}</div>
            //             <ul className="history_writer">
            //                 <li>
            //                     {data.editUser.name}
            //                 </li>
            //                 <li className="line" />
            //                 <li>
            //                     {newYear3}.{newMonth3}.{newDay3} ({newDayName3})
            //                 </li>
            //                 <li className="line" />
            //                 <li>
            //                     {newHours}:{newMinutes}
            //                 </li>
            //             </ul>
            //         </div>
            //         <div className="history_date">
            //             {/* {newYear}.{newMonth}.{newDay} ({newDayName}) - {newYear2}.{newMonth2}.{newDay2} ({newDayName2}) */}
            //             {
            //                 history.map((item, idx) => (<div>{item}</div>))
            //             }
            //         </div>
            //         <hr style={{border:0, height:1, backgroundColor:'#eeeeee'}}></hr>
            //     </div>
            // )
        })
        return List

        // const history = []
        //     data.forEach(function(process) {
        //         if (process.history.length > 0) {
        //             process.history.forEach(function(log) {
        //                 const item = {
        //                     processId: process.processId,
        //                     process: process.text,
        //                     startDate: log.startDate,
        //                     endDate: log.endDate,
        //                     reason: log.reason,
        //                     writeDate: process.writeDate,
        //                 }
        //                 history.push(item)
        //             })
        //         }
        //     })

        //     const ret = history.sort(function(a, b) {
        //         return a.writeDate - b.writeDate
        //     })

        //     this.setState({ history: ret })
    }

    render() {
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap section_wrap_menu">
                    <div className="intro_dashboard_wrap common_detail">
                        <div className="section">
                            <div className="radar_wrap">
                                {/* <div className="title"><div className="title_line"></div>현장 관리 지수</div> */}
                                <HighchartsReact
                                    highcharts={more(Highcharts)}
                                    options={scoreChartOptions}
                                    ref={'scoreChartRef'}
                                />
                                <hr />
                            </div>
                            <div className="pie_wrap">
                                {/* <div className="title"><div className="title_line"></div>공정별 인원 투입 현황</div> */}
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={pieChartOptions}
                                    ref={'pieChartRef'}
                                />
                                <hr />
                            </div>
                            <div className="line_wrap">
                                {/* <div className="title"><div className="title_line"></div>누적 인원 투입 현황</div> */}
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={lineChartOptions}
                                    ref={'lineChartRef'}
                                />
                                <hr />
                            </div>
                            <div className="stream_wrap">
                                {/* <div className="title"><div className="title_line"></div>주단위 공정 분포도</div> */}
                                <HighchartsReact
                                    highcharts={stream(Highcharts)}
                                    options={streamChartOptions}
                                    ref={'streamChartRef'}
                                />
                                {/* <hr /> */}
                            </div>

                            <div className="history_wrap">
                                {/* <div className="title"><div className="title_line"></div>스케쥴 변경 이력</div>
                {this.renderChangeHistory()}
                <br></br> */}
                                {/* <DataTable
                                    title="스케쥴 변경 이력"
                                    columns={historyColumns}
                                    data={this.state.history}
                                    dense
                                /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(IntroDashboard)



// WEBPACK FOOTER //
// ./Src/Containers/Intro/IntroDashboard.js